import React, { useState } from 'react'
import axios from 'axios'

import checkBox from '../../assets/check-box.png'
import { swalNotify } from '../../common/components/Swaler'
import { updateSwrCache } from '../../common/utils'

type Props = {
  deliveries: [],
}

const defaultProps = {
  deliveries: [],
  closeModal: Function,
}

const QToolsDeleteDelivery = ({ deliveries, closeModal }: Props) => {
  const [isLoading, setIsLoading] = useState(false)

  const onDeleteDelivery = () => {
    setIsLoading(true)

    const deliveryIds = deliveries.map((d) => d._id)

    axios.delete(`${window.MYQLOCX_API}/subject/${window.localStorage.userType}/deliveries`, { data: { deliveryIds } }).then(() => {
      swalNotify('Leverans raderad!')

      updateSwrCache('/subject/admin/deliveries?', (prev) => prev.filter((d) => !deliveryIds.includes(d._id)))
      closeModal()
    })
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 20 }}>
      <button className="smallQbutton" disabled={isLoading} onClick={onDeleteDelivery}>
        <img src={checkBox} style={{ width: 16, filter: 'invert(1)', marginRight: 16 }} alt="check-box" />
        {isLoading ? 'Raderar...' : 'Radera leverans'}
      </button>
    </div>
  )
}

QToolsDeleteDelivery.defaultProps = defaultProps

export default QToolsDeleteDelivery
